import React from 'react'
import { Box, type BoxProps } from '@chakra-ui/react'

export default function Span(props: BoxProps) {
    return <Box as="span" {...props} />
}
